import { FC, useEffect } from 'react';
import { driver, Config } from 'driver.js';

interface DesktopTourProps {
  steps: NonNullable<Config['steps']>;
  onComplete: () => void;
  onSkip: () => void;
}

/**
 * Tour guiado genérico via Driver.js (somente desktop).
 * Recebe os passos via `steps` — cada tour (main, cursos, ranking) define os seus.
 * Em mobile, ver MobileWelcomeModal.
 *
 * Visual repaginado com o design system h.lab via `popoverClass: 'hlab-tour'`
 * — os overrides ficam em `src/styles/tour.css`.
 */
const DesktopTour: FC<DesktopTourProps> = ({ steps, onComplete, onSkip }) => {
  useEffect(() => {
    const driverObj = driver({
      popoverClass: 'hlab-tour',
      showProgress: true,
      progressText: 'Passo {{current}} de {{total}}',
      nextBtnText: 'Próximo →',
      prevBtnText: '← Anterior',
      doneBtnText: 'Concluir',
      onDestroyStarted: () => {
        if (!driverObj.isLastStep()) {
          onSkip();
        }
        driverObj.destroy();
      },
      onDestroyed: () => {
        onComplete();
      },
      steps,
    });

    driverObj.drive();

    return () => {
      driverObj.destroy();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default DesktopTour;
